export default "__VITE_ASSET__CAG5lK6d__"